import React from 'react';
import MuiTab, { TabProps as MuiTabProps } from '@mui/material/Tab';

export type TabProps = MuiTabProps;

const Tab = React.forwardRef<React.ElementRef<typeof MuiTab>, TabProps>(
  function Tab(props, ref) {
    return <MuiTab ref={ref} {...props} />;
  },
);

export default Tab;
